import axios from 'axios'
import qs from 'qs'
import cookie from 'vux/src/tools/cookie/index.js'

import router from '../router/index'
import daoBaseConfig from '@/daoBaseConfig'

var daoBase = daoBaseConfig.getBasePath()

var manage = {
/*LOCATION
** 网站主域,cookie存储
*/
location: daoBase.domain, //cxc555.com//test.com
protocol: daoBase.protocol,
/*API接口
**  使用方法:
**    $xc.api.checkOutToken()
*/
api: {
header: daoBase.xcBasePath,//dev:http://192.168.0.106:8888/ ,,,http://192.168.0.106:8080/xcWeb/(http://192.168.0.113:8888/xcWeb/)  //build:http://192.168.0.59:8080/xcnet/  //http://192.168.0.57:8080/xcent/  //http://192.168.0.56:4009/
checkOutToken: ()=> {

return manage.api.header + 'login/checkOutToken'
},
phoneLogin: ()=> {

return manage.api.header + 'userLogin/mobilephoneLogin'
},
getCodeWithLogin: ()=> {

return manage.api.header + 'userLogin/getCodeWithLogin'
},
getNickNameWithLogin: ()=> {

return manage.api.header + 'userLogin/getNickNameWithLogin'
},
userCheckCodeWithLogin: ()=> {

return manage.api.header + 'userLogin/userCheckCodeWithLogin'
},
userRetrieveLoginPwd: ()=> {

return manage.api.header + 'userLogin/userRetrieveLoginPwd'
},
register: ()=> {

return manage.api.header + 'userLogin/register'
},
getCodeWithRegister: ()=> {

return manage.api.header + 'userLogin/getCodeWithRegister'
},
getQRCodeAfterRegister: ()=> {

return manage.api.header + 'userLogin/getQRCodeAfterRegister'
},
wxLoginphone: ()=> {

return manage.api.header + 'userLogin/wx_loginphone'
},
},
/*基础ajax封装
**  使用方法:(get示例)
**     Tips:页面需要引用import $xc from '~/manage/index'
**    $xc.ajax.get(url, callback=>{
**      console.log(callback.data)
**    })
*/
ajax: {
get: function(url, callback) { //https://bird.ioliu.cn/v1?url=为远程数据接口代理服务,解决get请求跨域问题
axios.get('https://bird.ioliu.cn/v1?url='+url)
.then(response=> {
if (response) {
if (callback && typeof(callback)==='function') {
callback(response.data)
}
}
})
response => {
console.log(error)
}
},
post: function(url, param, callback) {
router.app.$vux.loading.show()

axios.post(url, qs.stringify(param))
.then(response=> {
if (response) {
if (response.data.status === 0){
if (response.data.error) {
router.app.$vux.toast.text(response.data.error)
}
router.app.$vux.loading.hide()
return
}
if (response.data.status === 2) {
manage.cookie.delete('token')
location.href = manage.protocol+'www.'+manage.location+'/mobile/#/?returnUrl='+location.href
router.app.$vux.loading.hide()
return
}
if (response.data.token) {
manage.cookie.set('token', response.data.token, 365)
}
if (callback && typeof(callback)==='function') {
callback(response.data)
router.app.$vux.loading.hide()
}
}
})
.catch(function (error) {
console.log(error)
router.app.$vux.toast.text('粗错啦~请稍后重试')
router.app.$vux.loading.hide()
})
response => {
console.log(error)
router.app.$vux.loading.hide()
}
}
},
/*基础cookie封装
**  使用方法:(set示例)
**     Tips:页面需要引用import $xc from '~/manage/index'
**    $xc.cookie.set(name, val, day)
*/
cookie: {
set: function(name, val) {
cookie.set(name, val, {
domain: manage.location,
path: '/',
expires: 30
})
},
get: function(name) {
return cookie.get(name)
},
delete: function(name) {
cookie.remove(name, {
domain: manage.location,
path: '/'
})
/*VueCookie.delete(name)*/
}
},
/*SPA单页应用获取地址栏Query参数封装函数
**  使用方法:
**     Tips:页面需要引用import $xc from '~/manage/index'
**    $xc.getQueryString('returnUrl')
*/
getQueryString: (name) =>{
var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
var r = window.location.href.split('#/')[1].substr(1).match(reg);
if(r!=null)return  unescape(r[2]); return null;
},
/*JS判断输入字符串长度（汉字算两个字符，字母数字算一个）
**  使用方法:
**     Tips:页面需要引用import $xc from '~/manage/index'
**    $xc.getByteLen(val)
*/
getByteLen: (val) =>{
var len = 0;
for (var i = 0; i < val.length; i++) {
var a = val.charAt(i);
if (a.match(/[^\x00-\xff]/ig) != null) {
len += 2;
} else {
len += 1;
}
}
return len;
},
/*验证是否登录
**  使用方法:
**     Tips:页面需要引用import $xc from '~/manage/index'
**    $xc.isLogin()
*/
isLogin: () =>{
if (manage.cookie.get('token')) {
axios.post(manage.api.checkOutToken(), qs.stringify({token: manage.cookie.get('token')}))
.then(response=> {
if (response) {
if (response.data.status === 0){

return
}
if (response.data.status === 2) {
return
}
if (response.data.token) {
manage.cookie.set('token', response.data.token, 365)
}
if (router.app.$route.query.returnUrl) {
location.href = router.app.$route.query.returnUrl
} else {
location.href = manage.protocol+'member.'+manage.location+'/mobile/#/'
}
}
})
.catch(function (error) {
console.log(error)

})
response => {
console.log(error)
}
}
},
/*判断是否在新APP中打开
**
*/
isNewAndroidApp: () =>{
return navigator.userAgent.indexOf('Android_new_app') !== -1 ? true : false
}
}
export default manage



// WEBPACK FOOTER //
// ./src/manage/index.js